import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Modal, Table, Button } from 'react-bootstrap';
import API_CONFIG from '../../config/configurations';
import Icon from '../Icons';
import HelpVideoModal from './HelpVideoModal';
import HelpPdfModal from './HelpPdfModal';
import videoIcon from '../../assets/images/video-icon.png';
import './style.scss'; // Assuming we can use a local style file or add to global

const HelpSubcategoriesModal = ({ show, onHide, category }) => {
  const [videoModalShow, setVideoModalShow] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState('');
  const [pdfModalShow, setPdfModalShow] = useState(false);
  const [currentPdfUrl, setCurrentPdfUrl] = useState('');
  const [currentPdfTitle, setCurrentPdfTitle] = useState('');
  const location = useLocation();

  // Logic for visibility updated to use Route:
  // - If route contains '/profile/', it is the employee view -> Filter subcategories where viewCollaborator is true.
  // - If route DOES NOT contain '/profile/' (e.g. /dashboard, /company_reports) -> Show ALL subcategories.
  const isProfileView = location.pathname.includes('/profile/');

  const subcategories = category?.helpSubcategories || [];

  const filteredSubcategories = subcategories.filter(sub => {
    if (!isProfileView) return true; // Show all for non-profile views (HR, Admin, etc.)
    return sub.viewCollaborator; // Only show allowed ones for profile view
  });

  // Helper to check if fileUrl has valid content (not empty object)
  const hasValidFileUrl = fileUrl => {
    if (!fileUrl) return false;
    if (typeof fileUrl === 'object') {
      return Object.keys(fileUrl).length > 0 && fileUrl.fileUrl;
    }
    return typeof fileUrl === 'string' && fileUrl.length > 0;
  };

  const handleVideoClick = url => {
    setCurrentVideoUrl(url);
    setVideoModalShow(true);
  };

  const handlePdfClick = (url, name) => {
    // eslint-disable-next-line no-console
    console.log('PDF URL received:', url);
    let finalUrl = url;
    if (url && url.startsWith('/')) {
      finalUrl = `${API_CONFIG.domain}${url}`;
    }
    setCurrentPdfUrl(finalUrl);
    setCurrentPdfTitle(name);
    setPdfModalShow(true);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        dialogClassName="modal-left" // Custom class for left-aligned modal as per mockup
        className="help-subcategories-modal"
        backdrop
      >
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center">
            <div style={{ color: 'rgb(43, 180, 143)', fontWeight: 'bold', fontSize: '1.1rem' }}>
              Aprende con Peoplework
            </div>
            <div style={{ fontWeight: 'bold', fontSize: '1rem', color: '#333' }}>{category?.name}</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive">
            <Table borderless hover>
              <thead>
                <tr>
                  <th />
                  <th className="text-center">Video</th>
                  <th className="text-center">Manual</th>
                </tr>
              </thead>
              <tbody>
                {filteredSubcategories.map(sub => (
                  <tr key={sub.id}>
                    <td>{sub.name}</td>
                    <td className="text-center">
                      {sub.videoUrl && (
                        <Button variant="link" className="p-0" onClick={() => handleVideoClick(sub.videoUrl)}>
                          <img src={videoIcon} alt="Play" className="icon-video" />
                        </Button>
                      )}
                    </td>
                    <td className="text-center">
                      {hasValidFileUrl(sub.fileUrl) && (
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={() => handlePdfClick(sub.fileUrl?.fileUrl || sub.fileUrl, sub.name)}
                        >
                          <Icon icon="download-2" size={25} className="icon-manual" />
                        </Button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
      </Modal>

      <HelpVideoModal show={videoModalShow} onHide={() => setVideoModalShow(false)} videoUrl={currentVideoUrl} />
      <HelpPdfModal
        show={pdfModalShow}
        onHide={() => setPdfModalShow(false)}
        pdfUrl={currentPdfUrl}
        title={currentPdfTitle}
      />
    </>
  );
};

export default HelpSubcategoriesModal;
